import { useState } from "react";
import { Container, Form, H2 } from "../../Styles/Global.Styled";
import { Toast } from "../../Components/Toast/Toast";
import { css } from "styled-components";
import { requestContact } from "../../api/messages";
import {
  contactPrefProps,
  dailingCodeProps,
  emailProps,
  firstNameProps,
  lastNameProps,
  messageProps,
  phoneNumberProps,
} from "../../helpers/formProps";
import useToast from "../../hooks/useToast";
import {
  getFormComponent,
  getPhoneNoFormComp,
  processFormData,
} from "../../helpers/formHandlers";
import Message from "../../Components/Sections/Message";
import FormSubmissionBttn from "../../Components/Buttons/FormSubmissionBttn";
import SendIcon from "../../Icons/SendIcon";

const formStyle = css`
  align-items: center;
  gap: 4vh;
  width: 50%;
`;
const formMobile = css`
  padding: 0vh;
  width: 100%;
`;
const fontSize = css`
  font-size: 3vh;
`;
const gapSize = css`
  gap: 2vh;
`;

const contactFormData = [
  firstNameProps(),
  lastNameProps(),
  contactPrefProps(),
  emailProps(),
  dailingCodeProps(),
  phoneNumberProps(),
  messageProps(),
];

const ContactForm = () => {
  const [isLoading, setLoading] = useState(false);
  const [formData, setForm] = useState(contactFormData);
  const [formStep, setStep] = useState(0);
  const { toast, showToast, hideToast } = useToast();

  const submitForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const processedData = processFormData(formData);
      if (processedData.errors === true) {
        const firstError = processedData.formErrors[0];
        setLoading(false);
        showToast({
          title: `${firstError.label}`,
          text: `${firstError.errors}`,
          type: "Error",
        });
        return;
      }

      await requestContact(processedData);
      setStep(1);
    } catch (error) {
      showToast({ type: "Error", hidden: false });
    } finally {
      setLoading(false);
    }
  };

  const renderFields = (start, end) =>
    formData
      .slice(start, end)
      .map((props, index) =>
        getFormComponent({ props, setForm, index: index + start })
      );

  if (formStep === 0) {
    return (
      <Form
        id="contact-us-form"
        onSubmit={(e) => submitForm(e)}
        $baseStyle={formStyle}
        $mStyle={formMobile}
      >
        {!toast.hidden && (
          <Toast
            top="0"
            message={toast.text}
            title={toast.title}
            type={toast.type}
            hideToast={hideToast}
            position={"absolute"}
            height={"5vh"}
          />
        )}
        <H2 $mStyle={fontSize}>Send us a Message</H2>
        <Container $baseStyle={gapSize}>{renderFields(0, 2)}</Container>
        {renderFields(2, 4)}
        {getPhoneNoFormComp(formData[4], formData[5], setForm, 4, 5)}
        {getFormComponent({ props: formData[6], setForm, index: 6 })}
        <FormSubmissionBttn
          text="Submit"
          isLoading={isLoading}
          icon={<SendIcon />}
        />
      </Form>
    );
  }
  if (formStep === 1) {
    return (
      <Message
        type="success"
        header={"Thank you for contacting us!"}
        message={
          "We will review you your message, and get back to you as soon as possible"
        }
      />
    );
  }
};

export default ContactForm;
